import React from 'react';
import { useLocalization } from '@/Hooks';
import { ModalProps } from '@/Types';
import styles from './OrderLabelPrintModal.scss';
import { OrderLabelTable } from './modules/OrderLabelTable/OrderLabelTable';
import { Modal } from '@/Components/Modal/Modal';
import { Button } from '@/Components/Controls/Button/Button';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import { useOrderLabelPrintForm } from './hooks/useOrderLabelPrintForm';
import { useOrderLabelPrintOptions } from './hooks/useOrderLabelPrintOptions';
import { FormProvider } from '@/Hooks/useFormWrapper';
import { LabelFilter } from './modules/LabelFilter/LabelFilter';
import { ButtonsWrapper } from '@/Components/Forms/ButtonsSection/ButtonsSection';

type Props = ModalProps;

export function OrderLabelPrintModal({ closeModalWindow }: Props) {
  const {
    buttons,
    modalWindows: {
      orderLabelPrint: { Title, Buttons },
    },
  } = useLocalization();

  const { selectedOrderIds, isAllSelectedCreated } = useOrderLabelPrintOptions();

  const { methods, onSubmit, onPrintLabels } = useOrderLabelPrintForm(closeModalWindow);

  return (
    <Modal
      modalClassName={styles.modal}
      onClose={closeModalWindow}
      shouldCloseOnOverlayClick={false}
      description={{
        title: Title,
      }}
    >
      <FormProvider {...methods}>
        <form className={styles.formWrapper} onSubmit={onSubmit}>
          <LabelFilter />
          <OrderLabelTable selectedOrderIds={selectedOrderIds} />

          <ButtonsWrapper className={styles.buttonsWrapper}>
            <Button text={buttons.Cancel} theme={BUTTON_THEMES.SUCCESS_TRANSPARENT} onClick={closeModalWindow} />
            <Button
              text={Buttons.CreateLabes}
              theme={BUTTON_THEMES.SUCCESS}
              onClick={() => onPrintLabels(false)}
              disabled={isAllSelectedCreated}
            />
            <Button
              text={Buttons.PrintLables}
              theme={BUTTON_THEMES.SUCCESS}
              onClick={() => onPrintLabels(true)}
              disabled={!isAllSelectedCreated}
            />
            <Button
              text={Buttons.CreatePrintLables}
              theme={BUTTON_THEMES.SUCCESS}
              onClick={() => onPrintLabels(true)}
              disabled={isAllSelectedCreated}
            />
          </ButtonsWrapper>
        </form>
      </FormProvider>
    </Modal>
  );
}
